export const DEV_SLLR_BASE_API_URL = 'https://api-test.sllr.co/';
export const STAGING_SLLR_BASE_API_URL = 'https://api-stg.sllr.co/';
export const BETA_SLLR_BASE_API_URL = 'https://api-beta.sllr.co/';
export const PRODUCTION_SLLR_BASE_API_URL = 'https://api.sllr.co/';

export const BOSTA_WEBSITE_PRODUCTION_BASE_URL = 'bosta.co';
export const BOSTA_WEBSITE_STAGING_BASE_URL = 'stg.bosta.co';

export const SLLR_DASHBAORD_PRODUCTION_BASE_URL = 'dashboard.sllr.co';
export const SLLR_DASHBAORD_STAGING_BASE_URL = 'stg-dashboard.sllr.co';
export const SLLR_DASHBAORD_DEV_BASE_URL = 'dev-dashboard.sllr.co';

export const BUSINESS_DASHBOARD_PRODUCTION_BASE_URL = 'business.bosta.co';
export const BUSINESS_DASHBOARD_STAGING_BASE_URL = 'stg-business.bosta.co';
export const BUSINESS_DASHBOARD_DEV_BASE_URL = 'dev-business.bosta.co';
export const BUSINESS_DASHBOARD_BETA_BASE_URL = 'beta-business.bosta.co';

export const SLLR_STORES_DEV_BASE_URL = 'test.sllr.co';
export const SLLR_STORES__STAGING_BASE_URL = 'stg.sllr.co';
export const SLLR_STORES_BETA_PRODUCTION_BASE_URL = 'beta.sllr.co';
export const SLLR_STORES_PRODUCTION_BASE_URL = 'sllr.co';

export const LOCAL_HOST = 'localhost';

export const URLS = {
  SLLR_DASHBOARD: {
    [DEV_SLLR_BASE_API_URL]: SLLR_DASHBAORD_DEV_BASE_URL,
    [STAGING_SLLR_BASE_API_URL]: SLLR_DASHBAORD_STAGING_BASE_URL,
    [BETA_SLLR_BASE_API_URL]: SLLR_DASHBAORD_PRODUCTION_BASE_URL,
    [PRODUCTION_SLLR_BASE_API_URL]: SLLR_DASHBAORD_PRODUCTION_BASE_URL
  },
  WEBSITE: {
    [STAGING_SLLR_BASE_API_URL]: BOSTA_WEBSITE_STAGING_BASE_URL,
    [BETA_SLLR_BASE_API_URL]: BOSTA_WEBSITE_PRODUCTION_BASE_URL,
    [PRODUCTION_SLLR_BASE_API_URL]: BOSTA_WEBSITE_PRODUCTION_BASE_URL
  },
  SLLR_STORES: {
    [DEV_SLLR_BASE_API_URL]: SLLR_STORES_DEV_BASE_URL,
    [STAGING_SLLR_BASE_API_URL]: SLLR_STORES__STAGING_BASE_URL,
    [BETA_SLLR_BASE_API_URL]: SLLR_STORES_BETA_PRODUCTION_BASE_URL,
    [PRODUCTION_SLLR_BASE_API_URL]: SLLR_STORES_PRODUCTION_BASE_URL
  },
  BUSINESS_DASHBOARD: {
    [DEV_SLLR_BASE_API_URL]: BUSINESS_DASHBOARD_DEV_BASE_URL,
    [STAGING_SLLR_BASE_API_URL]: BUSINESS_DASHBOARD_STAGING_BASE_URL,
    [BETA_SLLR_BASE_API_URL]: BUSINESS_DASHBOARD_BETA_BASE_URL,
    [PRODUCTION_SLLR_BASE_API_URL]: BUSINESS_DASHBOARD_PRODUCTION_BASE_URL
  }
};
